import React from 'react';
import ModalBasic from '../../../pages/component/ModalBasic.js';
import MultiSelectDropdown from '../../dropdown/MultiSelectDropdown.js';
import moment from 'moment';
import ValidationText from '../../../utils/validation/ValidationText.js';
import DatePicker from 'react-datepicker';

const ItemDetailsModel = (props) => {
    return (
        <ModalBasic
            id="adding-item-popUp"
            modalOpen={props.setItemDetailsModel}
            setModalOpen={props.setOpenModel}
            title="Item Details"
            noCloseIcon={true}
        >
            <div className="item-form ">
                <div className="form-table">
                    {props.productionStockList && props.productionStockList.length > 0
                        ?
                        <div className="itemList-table mb-3">
                            <div className="table-container" style={{ maxHeight: "25vh" }} >
                                <table className="itemList">
                                    <thead>
                                        <tr>
                                            {props.page !== 'InvoiceRM' && props.page !== 'InvoicePM' ?
                                                <>
                                                    <td className='w-[20%]'>Batch No</td>
                                                    <td className='w-[20%]'>Exp Dt.</td>
                                                    <td className='w-[20%]'>M.R.P.</td>
                                                </>
                                                :
                                                <>
                                                    <td className='w-[20%]'>Name</td>
                                                    <td className='w-[20%]'>UOM</td>
                                                </>
                                            }
                                            <td className='w-[20%]'>Stock</td>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {props.productionStockList.map((item, key) => (
                                            <tr key={key} className='hover:bg-[#f3f4f673] cursor-pointer' onClick={() => props.selectQtyFromStock(item)}>
                                                {props.page !== 'InvoiceRM' && props.page !== 'InvoicePM' ?
                                                    <>
                                                        <td>{item.batchNo}</td>
                                                        <td>{moment(item.expDate).format("DD MMM yyyy")}</td>
                                                        <td>{item.mrp}</td>
                                                    </>
                                                    :
                                                    <>
                                                        <td className='w-[20%]'>{item.name}</td>
                                                        <td className='w-[20%]'>{item.uom ? item.uom : ''}</td>
                                                    </>
                                                }
                                                <td>{Number(item.quantity) > 0 ? Number(item.quantity).toFixed(2) : 0}</td>
                                                {/* <td>{item.HSNCode}</td> */}
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                        : props.validationTextForStock ?
                            <p
                                className=' mb-3 w-fit p-2 rounded-[8px]'
                                style={{
                                    color: "brown",
                                    fontSize: "13px",
                                    border: "1px solid #a52a2a57",
                                    outline: " 2px solid rgb(165 42 42 / 10%)",
                                }} >
                                {props.validationTextForStock}</p>
                            : null}


                    <div className="item-grp !flex !gap-2.5 !mb-2.5">
                        <div className="input-grp w-full">
                            <label>Item Name</label>
                            <MultiSelectDropdown
                                drpIdentity="itemId"
                                options={props.companyItemList}
                                className={` ${props.validState?.error?.itemId ? "errorInput" : ""}`}
                                closeMenuOnSelect={true}
                                hideSelectedOptions={false}
                                onChange={(selected) =>
                                    props.setFilterParametersForItemTable(
                                        selected,
                                        "itemId"
                                    )
                                }
                                allowSelectAll={false}
                                value={props.companyItemList.filter(
                                    (party) => party.value === props.itemDetails.itemId
                                )}
                            />
                            {/* <ValidationText error={props.validState.error.itemId} /> */}
                        </div>
                        {props.page !== 'InvoiceRM' && props.page !== 'InvoicePM' ?
                            <div className="input-grp min-w-[15%]">
                                <label>Packing</label>
                                <input
                                    type="text"
                                    id="packing"
                                    name="packing"
                                    autoComplete="off"
                                    value={props.itemDetails.packing}
                                    onChange={(event) =>
                                        props.handleChangeForItemTable(event, "packing")
                                    }
                                    disabled
                                    className="inputFocus"
                                />
                            </div>
                            : null
                        }
                        <div className="input-grp min-w-[15%]">
                            <label>Batch No</label>
                            <input
                                type="text"
                                id="batchNo"
                                name="batchNo"
                                autoComplete="off"
                                value={props.itemDetails.batchNo}
                                onChange={(event) =>
                                    props.handleChangeForItemTable(event, "batchNo")
                                }
                                className="inputFocus"
                                disabled={props.page !== 'InvoiceRM' && props.page !== 'InvoicePM'}
                            />
                        </div>
                        <div className="input-grp min-w-[20%]">
                            <label>Mfg Date</label>
                            {/* <input
                                type="date"
                                id="mfgDate"
                                name="mfgDate"
                                autoComplete="off"
                                value={props.itemDetails.mfgDate}
                                onChange={(event) =>
                                    props.handleChangeForItemTable(event, "mfgDate")
                                }
                                className="inputFocus"
                                disabled={props.page !== 'InvoiceRM' && props.page !== 'InvoicePM'}
                            /> */}
                            <DatePicker
                                selected={props.itemDetails.mfgDate}
                                className="inputFocus"
                                dateFormat="MM/yyyy"
                                showMonthYearPicker
                                onChange={(date) => props.handleChangeForDatePicker(date, "mfgDate")}
                                disabled={props.page !== 'InvoiceRM' && props.page !== 'InvoicePM'}
                            />
                            {/* <ValidationText error={props.validState.error.mfgDate} /> */}
                        </div>
                        <div className="input-grp min-w-[20%]">
                            <label>Exp. Date</label>
                            {/* <input
                                type="date"
                                id="expDate"
                                name="expDate"
                                autoComplete="off"
                                value={props.itemDetails.expDate}
                                onChange={(event) =>
                                    props.handleChangeForItemTable(event, "expDate")
                                }
                                className="inputFocus"
                                disabled={props.page !== 'InvoiceRM' && props.page !== 'InvoicePM'}
                            /> */}
                            <DatePicker
                                selected={props.itemDetails.expDate}
                                className="inputFocus"
                                dateFormat="MM/yyyy"
                                showMonthYearPicker
                                onChange={(date) => props.handleChangeForDatePicker(date, "expDate")}
                                disabled={props.page !== 'InvoiceRM' && props.page !== 'InvoicePM'}
                            />
                            {/* <ValidationText error={props.validState.error.expDate} /> */}
                        </div>
                    </div>
                    <div className="item-grp !flex !gap-2.5 mt-3">
                        {props.page !== 'InvoiceRM' && props.page !== 'InvoicePM' ?
                            <div className="input-grp w-full">
                                <label>MRP</label>
                                <input
                                    type="number"
                                    id="mrp"
                                    name="mrp"
                                    autoComplete="off"
                                    value={props.itemDetails.mrp}
                                    onChange={(event) =>
                                        props.handleChangeForItemTable(event, "mrp")
                                    }
                                    className="inputFocus1"
                                    disabled
                                />
                            </div>
                            : null
                        }
                        {props.page === 'InvoiceRM' || props.page === 'InvoicePM' ?
                            <div className="input-grp w-full">
                                <label>Make</label>
                                <input
                                    type="text"
                                    id="make"
                                    name="make"
                                    autoComplete="off"
                                    value={props.itemDetails.make}
                                    onChange={(event) =>
                                        props.handleChangeForItemTable(event, "make")
                                    }
                                    className="inputFocus"
                                />
                                {/* <ValidationText error={props.validState.error.make} /> */}
                            </div>
                            : null}
                        <div className="input-grp w-full">
                            <label>Quantity</label>
                            <input
                                type="number"
                                id="qty"
                                name="qty"
                                autoComplete="off"
                                className={`inputFocus ${props.validState?.error?.qty ? "errorInput" : ""}`}
                                disabled={(props.page !== 'InvoiceRM' && props.page !== 'InvoicePM') ? (props.itemDetails.batchClearingEntryId === null && props.itemDetails.batchNo === '') : false}
                                value={props.itemDetails.qty}
                                onChange={(event) =>
                                    props.handleChangeForItemTable(event, "qty")
                                }
                                onBlur={() => props.validateStockQty()}
                            />
                            {/* <ValidationText error={props.validState.error.qty} /> */}
                        </div>
                        <div className="input-grp min-w-[12%]">
                            <label>UOM</label>
                            <input
                                type="text"
                                id="UOM"
                                name="UOM"
                                autoComplete="off"
                                className="inputFocus"
                                disabled
                                value={props.itemDetails.uom}
                                onChange={(event) =>
                                    props.handleChangeForItemTable(event, "uom")
                                }
                            // onBlur={() => props.validateStockUOM()}
                            />
                            {/* <ValidationText error={props.validState.error.UOM} /> */}
                        </div>
                        {props.page !== 'InvoiceRM' && props.page !== 'InvoicePM' ?
                            <div className="input-grp w-full">
                                <label>Free</label>
                                <input
                                    type="number"
                                    id="free"
                                    name="free"
                                    autoComplete="off"
                                    className="inputFocus"
                                    disabled={props.itemDetails.batchClearingEntryId === null && props.itemDetails.batchNo === ''}
                                    value={props.itemDetails.free}
                                    onChange={(event) =>
                                        props.handleChangeForItemTable(event, "free")
                                    }
                                    onBlur={() => props.validateStockQty()}
                                />
                            </div>
                            : null}
                        <div className="input-grp w-full">
                            <label>Rate</label>
                            <input
                                type="number"
                                id="rate"
                                name="rate"
                                autoComplete="off"
                                className={` inputFocus ${props.validState?.error?.rate ? "errorInput" : ""}`}
                                disabled={props.itemDetails.isNonInventory === false && props.itemDetails.batchClearingEntryId === null && props.itemDetails.batchNo === ''}
                                value={props.itemDetails.rate}
                                onChange={(event) =>
                                    props.handleChangeForItemTable(event, "rate")
                                }
                            />
                            {/* <ValidationText error={props.validState.error.rate} /> */}
                        </div>
                        <div className="input-grp w-full">
                            <label>Amount</label>
                            <input
                                type="number"
                                id="amount"
                                name="amount"
                                autoComplete="off"
                                className='inputFocus'
                                disabled
                                value={props.itemDetails.amount}
                                onChange={(event) =>
                                    props.handleChangeForItemTable(event, "amount")
                                }
                            />
                        </div>

                    </div>
                    <div className="item-grp !flex !gap-2.5 mt-3">
                        {props.page !== 'InvoiceRM' && props.page !== 'InvoicePM' ?
                            <>
                                <div className="input-grp min-w-[10%]">
                                    <label>Disc. Rate</label>
                                    <input className="inputFocus"

                                        type="number"
                                        id="discRate"
                                        name="discRate"
                                        autoComplete="off"
                                        value={props.itemDetails.discRate}
                                        onChange={(event) =>
                                            props.handleChangeForItemTable(event, "discRate")
                                        }
                                    />
                                </div>
                                <div className="input-grp min-w-[12%]">
                                    <label>Disc. Amt</label>
                                    <input
                                        type="number"
                                        id="discAmount"
                                        name="discAmount"
                                        autoComplete="off"
                                        className='inputFocus'
                                        disabled
                                        value={props.itemDetails.discAmount}
                                        onChange={(event) =>
                                            props.handleChangeForItemTable(event, "discAmount")
                                        }
                                    />
                                </div>
                                <div className="input-grp min-w-[15%]">
                                    <label>Taxable Amount</label>
                                    <input
                                        type="number"
                                        id="taxableAmount"
                                        name="taxableAmount"
                                        autoComplete="off"
                                        className='inputFocus'
                                        disabled
                                        value={props.itemDetails.taxableAmount}
                                        onChange={(event) =>
                                            props.handleChangeForItemTable(event, "taxableAmount")
                                        }
                                    />
                                </div>
                            </>
                            : null}

                        <div className="input-grp w-full">
                            <label>HSN Code</label>
                            <MultiSelectDropdown
                                drpIdentity="hsnCodeId"
                                options={props.hsnCodeList}
                                closeMenuOnSelect={true}
                                hideSelectedOptions={false}
                                className={` ${props.validState?.error?.hsnCodeId ? "errorInput" : ""}`}
                                onChange={(selected) =>
                                    props.setFilterParametersForItemTable(
                                        selected,
                                        "hsnCodeId",
                                    )
                                }
                                allowSelectAll={false}
                                value={props.hsnCodeList.filter(
                                    (party) => party.value === props.itemDetails.hsnCodeId
                                )}
                            />
                            {/* <ValidationText error={props.validState.error.hsnCodeId} /> */}
                        </div>
                        <div className="input-grp !min-w-[10%]">
                            <label>SGST [%]</label>
                            <input className="inputFocus"

                                type="number"
                                id="sgst"
                                name="sgst"
                                autoComplete="off"
                                value={props.itemDetails.sgst}
                                onChange={(event) =>
                                    props.handleChangeForItemTable(event, "sgst")
                                }
                                disabled
                            />
                        </div>
                        <div className="input-grp !min-w-[10%]">
                            <label>CGST [%]</label>
                            <input className="inputFocus"

                                type="number"
                                id="cgst"
                                name="cgst"
                                autoComplete="off"
                                value={props.itemDetails.cgst}
                                onChange={(event) =>
                                    props.handleChangeForItemTable(event, "cgst")
                                }
                                disabled
                            />
                        </div>
                        <div className="input-grp !min-w-[10%]">
                            <label>IGST [%]</label>
                            <input className="inputFocus"

                                type="number"
                                id="igst"
                                name="igst"
                                autoComplete="off"
                                value={props.itemDetails.igst}
                                onChange={(event) =>
                                    props.handleChangeForItemTable(event, "igst")
                                }
                                disabled
                            />
                        </div>
                        <div className="input-grp !min-w-[10%]">
                            <label>UGST [%]</label>
                            <input className="inputFocus"

                                type="number"
                                id="ugst"
                                name="ugst"
                                autoComplete="off"
                                value={props.itemDetails.ugst}
                                onChange={(event) =>
                                    props.handleChangeForItemTable(event, "ugst")
                                }
                                disabled
                            />
                        </div>


                    </div>
                    <div className="btn-grp flex gap-2.5 mt-5">
                        {props.isEditing ?
                            <button
                                className="add-btn"
                                onClick={props.addItemToItemArray}
                            >
                                Save
                            </button> :
                            <button
                                className="add-btn"
                                onClick={props.addItemToItemArray}
                            >
                                Add
                            </button>
                        }

                        <button
                            className="cancel-btn"
                            onClick={props.closePopUp}
                        >
                            Cancel
                        </button>
                    </div>
                </div>
            </div>
        </ModalBasic>
    );
};

export default ItemDetailsModel;